import EmailComposer from '@/components/common/EmailComposer'

export default function TeacherSendEmail() {
  return <EmailComposer allowedRecipientRoles={['student', 'teacher']} senderRole="teacher" />
}
